/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import Barcode from 'react-barcode';
import commonUtil from './../../../../../utils/commonUtil';
import { handleGetEventCardDetails } from './actions';
import * as labelsActions from '../../../../../components/labels/actions';
import ApplyCSS from './../../../../../components/ApplyCSS';
import * as defaultConst from '../../../../../utils/clientConstant';
import Tagging from '../../../../../components/Tagging/Tagging';

const channel = commonUtil.getChannel();
const pageName = 'celebratedCard';

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  globleObj: store.globleObject,
}),
  { ...labelsActions })

class CelebratedCard extends Component {
  UNSAFE_componentWillMount() {
    const user = this.props.user;
    if (!(user && user.result && user.result.status && user.result.status.status === defaultConst.constAPISuccess)) {
      if (browserHistory) {
        browserHistory.push('/');
      }
    }
    const eventID = this.props.eventId;
    if (eventID) {
      this.props.handleGetEventCardDetails(eventID);
    }
  }
  componentDidMount() {
    const eventUrl = 'gestiondeeventos/TarjetaDeFestejado/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Tarjeta de festejado',
      Site: 'Mesa de Regalos',
      idMesa: this.props.eventId,
    });
  }
  render() {
    const { eCardDetails, lables } = this.props;
    const eventName = eCardDetails && eCardDetails.eventName ? eCardDetails && eCardDetails.eventName : '';
    const eventId = eCardDetails && eCardDetails.eventId ? eCardDetails && eCardDetails.eventId : '';
    const eCardId = eCardDetails && eCardDetails.cardNumber ? eCardDetails && eCardDetails.cardNumber : '';
    if (!eCardId) {
      return null;
    }
    return (
      <div className={channel === 'web' ? 'oppeningContainer celebratedCard' : 'oppeningContainer myEventContent'}>
        <ApplyCSS pageName={pageName} />
        <Tagging ref={tagging => this.tagging = tagging} />
        <div className="col-md-12">
          <h1 className={channel === 'web' ? 'titleSection' : 'noBorder'}>{commonUtil.getLabel(lables['Event management employee card page'], 'eventManagement.celebrationsCards.title')}</h1>
          <h2 className="subtitleModule"> {commonUtil.getLabel(lables['Event management employee card page'], 'eventManagement.celebrationsCards.subTitle')}</h2>
          <p className={channel === 'web' ? 'informativeTextSecond' : 'mainTextSecond'}>
            {commonUtil.getLabel(lables['Event management employee card page'], 'eventManagement.celebrationsCards.cardUseMessage')}</p>
          <div className="row">
            <div className="col-md-6">
              <div className="celebratedGift">
                <div className="celebratedName">{commonUtil.getLabel(lables['Event management employee card page'], 'eventManagement.celebrationsCards.title')}</div>
                <div className="celebratedNumber">{eCardId}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="celebratedGift">
                <p className="giftEvent">{eventName}/{eventId} </p>
                <div className="barcode">
                  <Barcode value={eCardId} format="CODE128" width={1} height={15} textAlign="center" fontSize={11} />
                </div>
                <div className="celebratedName gray">{eCardId}</div>
              </div>
            </div>

          </div>
          <p className={channel === 'web' ? 'informativeTextSecond' : 'mainTextSecond'}> {commonUtil.getLabel(lables['Event management employee card page'], 'eventManagement.celebrationsCards.cardUseDirections')}</p>
        </div>
      </div>

    );
  }
}
const mapStateToProps = state => ({
  lables: state.labels.data,
  eCardDetails: state.eCardDetails.data.ecardDetailsInfo,
  user: state.user.data,
  eventId: state.eventDetails.userEventDetails.eventDetailsInfo.eventId,
});
const matchDispatchToProps = dispatch => bindActionCreators({ handleGetEventCardDetails }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(CelebratedCard);

